import React from 'react';

import TextButton from 'CommonComponents/TextButton';

import EditIcon from 'Assets/icons/edit.svg';
import TrashIcon from 'Assets/icons/trash.svg';

export default function ProcurementCategoriesTableRow(props) {
    return (
        <tr className="tw-cursor-pointer">
            <td>{props.category.name}</td>
            <td className="tw-whitespace-pre-wrap">{props.category.info}</td>
            <td>
                <div className="tw-flex tw-items-center tw-gap-x-3">
                    <TextButton onClick={() => props.editCategory(props.category)}>
                        <EditIcon className="tw-w-3 tw-h-3" />
                        {$t('Edit')}
                    </TextButton>
                    <TextButton onClick={() => props.deleteCategory(props.category)}>
                        <TrashIcon className="tw-w-3 tw-h-3" />
                        {$t('Delete')}
                    </TextButton>
                </div>
            </td>
        </tr>
    );
}
